import { useEffect, useState } from "react";

import jBox from "jbox";
import $ from "jquery";

const ModalEditProfileCancel = ({
  open = false,
  onClose = (editProfileCancel) => {},
}) => {
  const [modal, setModal] = useState(null);

  const openModal = () => {
    modal.open();
  };

  const closeModal = (editProfileCancel) => {
    modal.close();
    onClose(editProfileCancel);
  };

  const listenerCloseModal = () => {
    const btnCloseModal = document.getElementById("btnCloseModalEditProfileCancel");
    btnCloseModal.addEventListener("click", () => {
      closeModal(false);
    });
  };

  const listenerEditProfileCancel = () => {
    const btnEditProfileCancel = document.getElementById(
      "btnEditProfileCancel"
    );
    btnEditProfileCancel.addEventListener("click", () => {
      closeModal(true);
    });
  };

  /* First event render */
  useEffect(() => {
    const initModal = new jBox("Modal", {
      closeButton: false,
      closeOnClick: false,
      minWidth: 325,
      maxWidth: 375,
      content: $("#ModalEditCancel"),
    });
    setModal(initModal);

    return () => {
      initModal.destroy();
    };
  }, []);
  /* End First event render */

  useEffect(() => {
    // console.log("modalQrCode useEffect2!! >>", modalQrCode, open);

    if (modal && open) {
      openModal();
      listenerCloseModal();
      listenerEditProfileCancel();
    }
  }, [modal, open]);

  return (
    <div className="bModal bCard" id="ModalEditCancel">
      <div className="bInner">
        <div className="bDetail">
          <p>ยกเลิกการแก้ไข</p>
          <p className="detail">
            หากกดยืนยัน ระบบจะไม่ทำการบันทึก
            <br />
            ข้อมูลที่ได้ทำการแก้ไขล่าสุด
          </p>
        </div>
        <div className="group-Btn">
          <div className="modlaBtn" id="btnEditProfileCancel">
            <a className="confirmBtn btnCloseModal" href="#">
              ยืนยัน
            </a>
          </div>
          <div className="modlaBtn outline" id="btnCloseModalEditProfileCancel">
            <a className="confirmBtn btnCloseModal" href="#">
              ยกเลิก
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalEditProfileCancel;
